import { createTheme } from "@mui/material";
import { COMPONENTS, DARK, PRIMARY_COLOR, TYPOGRAPHY } from "../enums/themeEnums";

const darkTheme = createTheme({
  palette: {
    mode: DARK,
    primary: {
      main: '#D9C5B2'
    },
    background: {
      default: '#1A1614',
      paper: '#251F1C'
    },
    text: {
      primary: '#F2E9E1',
      secondary: '#B0A49E'
    },
    divider: 'rgba(217, 197, 178, 0.2)'
  },
  shape: {
    borderRadius: 12
  },
  typography: { ...TYPOGRAPHY },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#1A1614',
          color: '#F2E9E1',
          padding: 0,
          margin: 0,
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundImage: `radial-gradient(circle at 50% 50%, transparent 0%, #1A1614 70%), url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23D9C5B2' fill-opacity='0.15'/%3E%3C/svg%3E")`,
          backgroundAttachment: 'fixed',
          backgroundSize: '100% 100%, 24px 24px',
        },
        '::selection': {
          backgroundColor: '#D9C5B2',
          color: '#1A1614',
        },
        '.MuiDialog-root .MuiBackdrop-root': {
          backgroundColor: 'rgba(26, 22, 20, 0.8) !important',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#251F1C',
          backgroundImage: 'none',
          border: '1px solid #3D342F',
          borderRadius: '12px',
          boxShadow: '0 30px 60px rgba(0,0,0,0.5)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#251F1C',
          backgroundImage: 'none',
          border: '1px solid #3D342F',
          borderRadius: '12px',
          boxShadow: 'none',
          padding: '32px',
          transition: 'border-color 0.2s ease',
          '&:hover': {
            borderColor: '#4D413B',
          },
        }
      }
    },
    ...COMPONENTS
  }
});

export default darkTheme;